import { ClientModel } from './model';
import { AuthController } from '../auth/controller';
import { RequestController } from '../request/controller';
import { UIController } from '../ui/controller';
import { PlayerController } from '../player/controller';
import { APIController } from '../api/controller';
import { PageController } from '../page/controller';
import { BasketController } from '../basket/controller';
import { MailchimpController } from '../mailchimp/controller';
import { BugsnagController } from '../bugsnag/controller';
import { UserController } from '../user/controller';
import { AnalyticsController } from '../analytics/controller';
import { FlashController } from '../flash/controller';
import { PusherController } from '../pusher/controller';
import { OnboardingController } from '../onboarding/controller';
import { CheckoutController } from '../checkout/controller';
import { PrismicController } from '../prismic/controller';
import { ImageController } from '../image/controller';
import { ContentController } from '../content/controller';
import { ModalController } from '../modal/controller';
import { CouponController } from '../coupon/controller';
import { PricingController } from '../pricing/controller';
import { PlaylistController } from '../playlist/controller';
import { CacheController } from '../cache/controller';
import { ArtistlistController } from '../artistlist/controller';
import {GraphQLController} from '../graphql/controller';
import {Controller} from '../../types';

export class ClientController implements Controller {
  cache: CacheController;
  graphql: GraphQLController;
  ui: UIController;
  request: RequestController;
  api: APIController;
  auth: AuthController;
  mailchimp: MailchimpController;
  analytics: AnalyticsController;
  bugsnag: BugsnagController;
  prismic: PrismicController;
  content: ContentController;
  flash: FlashController;
  pusher: PusherController;
  image: ImageController;

  player: PlayerController;
  playlist: PlaylistController;
  artistlist: ArtistlistController;
  page: PageController;
  basket: BasketController;
  user: UserController;
  coupon: CouponController;
  onboarding: OnboardingController;
  checkout: CheckoutController;
  modal: ModalController;
  pricing: PricingController;

  constructor(private model: ClientModel) {
    this.cache = new CacheController(model.cache);
    this.bugsnag = new BugsnagController(model.env, model.auth);
    this.graphql = new GraphQLController(model.graphql, model.env);
    this.flash = new FlashController(model.flash, model.env, model.content, this.bugsnag);
    this.request = new RequestController(model.env, model.auth, model.storage, model.request);
    this.api = new APIController(this.request, this.cache, model.env);
    this.auth = new AuthController(model.auth, model.storage, this.request);
    this.mailchimp = new MailchimpController(model.mailchimp, model.auth);
    this.analytics = new AnalyticsController(model.env, model.router, model.auth, model.basket, model.content, model.coupon, this.bugsnag);
    this.player = new PlayerController(model.player, this.api.analytics, this.analytics, model.env);
    this.prismic = new PrismicController(model.env);
    this.content = new ContentController(model.content, model.env, this.prismic, this.graphql);
    this.pusher = new PusherController(model.pusher, model.env, model.auth, this.flash);
    this.image = new ImageController(model.image, model.env);

    this.playlist = new PlaylistController(model.playlist, model.env, model.user, this.api, this.bugsnag);
    this.artistlist = new ArtistlistController(model.artistlist, model.env, model.user, this.api, this.bugsnag);
    this.basket = new BasketController(model.basket, model.storage, this.api, model.env, model.user, this.flash, model.onboarding, this.analytics, this.image);
    this.coupon = new CouponController(model.coupon, model.env, model.content, this.api, this.flash, model.user);
    this.user = new UserController(model.user, this.api, this.basket, this.auth);
    this.onboarding = new OnboardingController(model.onboarding, model.env, this.api, this.auth, this.flash, model.storage, this.bugsnag, this.prismic, this.analytics, model.content, this.coupon);
    this.ui = new UIController(model.ui, model.auth, model.storage, this.flash, model.env, model.content, this.player, model.router, this.auth, this.onboarding);
    this.checkout = new CheckoutController(model.env, model.checkout, this.api, model.page.checkout, this.basket, this.flash, this.ui, this.analytics, this.auth, this.bugsnag, model.router, model.content, this.coupon);
    this.page = new PageController(model, this.api, this.auth, this.basket, this.ui, this.flash, this.checkout, this.prismic, this.bugsnag, this.image, this.analytics, this.playlist);
    this.pricing = new PricingController(model.pricing, this.api, this.bugsnag, model.env);
    this.modal = new ModalController(model.modal, this.api, model.auth, this.ui, this.bugsnag, this.auth, this.user, model.env, this.basket, this.pricing, model.content, this.flash, model.router);
  }

  disposeAll = () => {
    this.ui.dispose();
    this.auth.dispose();
    this.analytics.dispose();
    this.bugsnag.dispose();
    this.pusher.dispose();
    this.player.dispose();
    this.basket.dispose();
    this.user.dispose();
    this.coupon.dispose();
    this.onboarding.dispose();
    this.checkout.dispose();
    this.playlist.dispose();
    this.artistlist.dispose();
  }
}